import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { SOCIAL_LINKS } from "@/lib/socialLinks";

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  linkedin: Linkedin,
};

/** Light theme only: both variants render on light backgrounds. */
const VARIANTS = {
  light:
    "inline-flex items-center justify-center w-11 h-11 rounded-full border border-brand-200 bg-white text-brand-600 hover:text-ink hover:border-brand-500 hover:bg-brand-50 transition-colors",
};

export function SocialLinks({ className = "", variant = "light" }) {
  const linkClass = VARIANTS[variant] || VARIANTS.light;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {SOCIAL_LINKS.map((link) => {
        const Icon = ICONS[link.id];
        return (
          <a
            key={link.id}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
            aria-label={link.label}
          >
            <Icon className="w-4 h-4" aria-hidden="true" />
          </a>
        );
      })}
    </div>
  );
}
